/**
 * Web user settings store — localStorage placeholder
 * TODO: Replace with /users/me API when auth is implemented
 */
import { createUserSettingsStore, ISettingsConfigProvider, mergeSettingsConfig, sharedClientSettings } from '@edgerunner/shared/main';
import { webSettingsPersistence } from '../adapters/webSettingsPersistence';

// Web uses only shared settings; desktop-only settings excluded via package separation
const webSettingsConfigProvider: ISettingsConfigProvider = {
	getSettingsConfig: () => mergeSettingsConfig(sharedClientSettings),
};

export const useUserSettingsStore = createUserSettingsStore(
	webSettingsPersistence,
	webSettingsConfigProvider
);
